import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import HasilPenunjang from "@/services/HasilPenunjang";

interface LabResultRecent {
  tgl_order: string;
  acc_date: string;
  register: number;
  rm: string;
  acc_by: string;
  no_sample: string;
  items: string[];
}

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "global-notification"
})
class GlobalNotification extends VuexModule {
  loading = false;
  labResult: LabResultRecent[] = [];

  @Mutation
  SET_LABRESULT(val: LabResultRecent[]) {
    this.labResult = val;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation
  RESET_STORE() {
    this.labResult = [];
  }

  @Action({ rawError: true })
  async getLabResult(params): Promise<void> {
    this.SET_LABRESULT([]);

    const ut = params.unit_id;
    const resp = await HasilPenunjang.getRecentLabResult(ut).finally(() => {
      // this.SET_LOADING(false);
    });

    this.SET_LABRESULT(resp?.data);
  }

  @Action({ rawError: true })
  resetLab(): void {
    this.SET_LABRESULT([]);
  }

  @Action({ rawError: true })
  reset(): void {
    this.RESET_STORE();
  }
}

export default getModule(GlobalNotification);
export { LabResultRecent };
